import { render, staticRenderFns } from "./LightboxClose.vue?vue&type=template&id=23e47a9a"
import script from "./LightboxClose.vue?vue&type=script&lang=js"
export * from "./LightboxClose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports